import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-riverCross",
  "use": "icon-riverCross-usage",
  "viewBox": "0 0 30 23",
  "content": "<symbol viewBox=\"0 0 30 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-riverCross\">\r\n<path d=\"M0.773438 0V21.8377H29.0691\" stroke=\"currentColor\" />\r\n<path d=\"M5.13672 8.16943L11.9949 18.1189H18.177L24.0701 8.16943\" stroke=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol